import { Schema_TravelHealthV1BerlinDirektDe } from '@flows/insurance/schemas'

const schema = Schema_TravelHealthV1BerlinDirektDe

export default schema
